module.exports = __webpack_public_path__ + "img/screen-backup-restore.163f5bc6.jpg";